import { getAnalytics, logEvent, setUserId, setUserProperties } from 'firebase/analytics';
import { app } from './firebaseConfig';

// Initialize Firebase Analytics
export const analytics = getAnalytics(app);

/**
 * Track a page view event
 * @param pageName - The name of the page being viewed
 * @param additionalParams - Any additional parameters to include with the event
 */
export const trackPageView = (pageName: string, additionalParams = {}) => {
  logEvent(analytics, 'page_view', {
    page_title: pageName,
    page_location: window.location.href,
    page_path: window.location.pathname,
    ...additionalParams,
  });
  console.log(`Analytics: Page view tracked - ${pageName}`);
};

/**
 * Track a custom event
 * @param eventName - The name of the event to track
 * @param eventParams - Parameters to include with the event
 */
export const trackEvent = (eventName: string, eventParams = {}) => {
  logEvent(analytics, eventName, eventParams);
  console.log(`Analytics: Event tracked - ${eventName}`);
};

/**
 * Set user ID for analytics
 * @param uid - The user ID to set
 */
export const setAnalyticsUserId = (uid: string | null) => {
  if (uid) {
    setUserId(analytics, uid);
    console.log(`Analytics: User ID set - ${uid}`);
  }
};

/**
 * Set user properties for analytics
 * @param properties - The user properties to set
 */
export const setAnalyticsUserProperties = (properties: Record<string, any>) => {
  setUserProperties(analytics, properties);
  console.log('Analytics: User properties set');
};
